import { GameObject, GameComponent, Game } from '../GameEngine/src/core';
import { MoveComponent, PositionInterpolatorComponent, SwitchComponent } from '../GameEngine/src/basic'
import { Sprite, TileComponent, SpriteRenderingComponent, SpriteAnimationComponent } from '../GameEngine/src/render/sprite';
import * as Easing from '../GameEngine/src/Easing';

  var /* Constants */
      GAME_WIDTH = 1280,
      GAME_HEIGHT = 960,

      PLAYER_X = 720,
      PLAYER_START_X = 270,
      PLAYER_Y = 670,
      ENEMY_X = 720,
      ENEMY_START_X = 270,
      ENEMY_Y = 820,
      POSITION_STEP = 100,
      SPRITE_SPEED = 60,  // FPS
      TRACK_SPEED = -0.8, // Object velocityY

      /* Bootstrap */
      canvas,

      game,

      textures,
      sounds,

      worldSystem,
      cameraSystem,
      renderSystem,
      // inputSystem,

      // Shared Components
      spriteRenderingComponent,
      spriteAnimationComponent,
      lightsSpriteAnimation,
      pPIC,
      aPIC,

      trackBackgroundObject,
      trackForegroundObject,
      trackMarkingsObject,
      playerObject,
      aiObject,
      startLineObject,
      lightsObject,
      tvScreen,

      playerFlameComponent,
      enemyFlameComponent,

      tealSpriteSheet,
      redSpriteSheet,
      greenSpriteSheet,
      blueSpriteSheet;

  function setup(_canvas, screen){

    canvas = _canvas;

    game = new Game({
      width: GAME_WIDTH,
      height: GAME_HEIGHT
    });

    game.setCanvas(canvas);

    textures = game.loadTextures([
      /*  0 */ require("../img/Background/track.png"),
      /*  1 */ require("../img/Background/track-foreground.png"),
      /*  2 */ require("../img/Misc/verge.png"),
      /*  3 */ require("../img/Racers/teal.ss.png"),
      /*  4 */ require("../img/Racers/red.ss.png"),
      /*  5 */ require("../img/Misc/startline.png"),
      /*  6 */ require("../img/Misc/lights-red.png"),
      /*  7 */ require("../img/Misc/lights-red-amber.png"),
      /*  8 */ require("../img/Misc/lights-green.png"),
      /*  9 */ require("../img/Misc/P1.png"),
      /* 10 */ require("../img/Misc/flame.png"),
      /* 11 */ require("../img/Racers/green.ss.png"),
      /* 12 */ require("../img/Racers/blue.ss.png"),
    ]);

    worldSystem = game.getDefaultWorld();
    cameraSystem = game.getDefaultCamera();
    renderSystem = game.getDefaultRenderer();
    // inputSystem = game.getDefaultInput(screen);

    tealSpriteSheet = Sprite.generateSpriteSheet({
      t: textures[3], x: 0, y: 0, w: 238, h: 193, ox: 238, oy: 193
    }, 1, 22);
    redSpriteSheet = Sprite.generateSpriteSheet({
      t: textures[4], x: 0, y: 0, w: 280, h: 182, ox: 265, oy: 182
    }, 1, 22);
    greenSpriteSheet = Sprite.generateSpriteSheet({
      t: textures[11], x: 0, y: 0, w: 253, h: 167, ox: 238, oy: 167, d: 60
    }, 1, 4);
    blueSpriteSheet = Sprite.generateSpriteSheet({
      t: textures[12], x: 0, y: 0, w: 253, h: 167, ox: 238, oy: 167, d: 60
    }, 1, 4);

    // Shared Components
    spriteRenderingComponent = new SpriteRenderingComponent(renderSystem);
    spriteAnimationComponent = new SpriteAnimationComponent(1000/SPRITE_SPEED);
    spriteAnimationComponent.stop();

    trackBackgroundObject = new GameObject();
    trackBackgroundObject.sprite = {
      t: textures[0], x: 0, y: 0, w: 1280, h: 960, ox: 0, oy: 0
    };
    trackBackgroundObject.addComponent(spriteRenderingComponent);

    trackForegroundObject = new GameObject();
    trackForegroundObject.setPosition(0, 730);
    trackForegroundObject.sprite = {
      t: textures[1], x: 20, y: 0, w: 1280, h: 232, ox: 0, oy: 0
    };
    trackForegroundObject.addComponent(spriteRenderingComponent);

    trackMarkingsObject = new GameObject();
    var trackMarkingsY = 370,
        trackMarkingsBounds = [0,trackMarkingsY,GAME_WIDTH, trackMarkingsY + 528];
    trackMarkingsObject.setPosition(0, trackMarkingsY);
    trackMarkingsObject.addComponent(new MoveComponent());
    trackMarkingsObject.addComponent(new TileComponent(renderSystem, textures[2], trackMarkingsBounds));

    playerObject = new GameObject();
    playerObject.setPosition(PLAYER_START_X, PLAYER_Y);

    var src = new SpriteRenderingComponent(renderSystem, 1);
    src.addComponent(new SpriteAnimationComponent(50, [{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340 -64, oy: 80,
      },{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340 - 32, oy: 80,
      },{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340, oy: 80,
      }]));

    playerFlameComponent = new SwitchComponent();
    playerFlameComponent.addComponent(src);
    playerObject.addComponent(playerFlameComponent);
    playerFlameComponent.setActive(false);

    playerObject.sprites = blueSpriteSheet;
    playerObject.addComponent(spriteAnimationComponent);
    playerObject.addComponent(spriteRenderingComponent);
    pPIC = new PositionInterpolatorComponent(
      1500,
      Easing.BackOut
    );
    playerObject.addComponent(pPIC);
    playerObject.addComponent(new SpriteRenderingComponent(renderSystem, 1, {
        t: textures[9], x: 0, y: 0, w: 42, h: 88, ox: 130, oy: 270, d: 1000,
      }));

    aiObject = new GameObject();
    aiObject.setPosition(ENEMY_START_X, ENEMY_Y);

    var src = new SpriteRenderingComponent(renderSystem, 1);
    src.addComponent(new SpriteAnimationComponent(50, [{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340 -64, oy: 80,
      },{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340 - 32, oy: 80,
      },{
        t: textures[10], x: 0, y: 0, w: 128, h: 64, ox: 340, oy: 80,
      }]));
    enemyFlameComponent = new SwitchComponent();
    enemyFlameComponent.addComponent(src);
    aiObject.addComponent(enemyFlameComponent);
    enemyFlameComponent.setActive(false);

    aiObject.sprites = greenSpriteSheet;
    aiObject.addComponent(spriteAnimationComponent);
    aiObject.addComponent(spriteRenderingComponent);
    aPIC = new PositionInterpolatorComponent(
      1000,
      Easing.BackInOut
    );
    aiObject.addComponent(aPIC);

    startLineObject = new GameObject();
    startLineObject.sprite = {
      t: textures[5], x: 0, y: 0, w: 493, h: 302, ox: 0, oy: 0
    };
    startLineObject.setPosition(-200, 550);
    startLineObject.addComponent(spriteRenderingComponent);
    startLineObject.addComponent(new MoveComponent());

    lightsObject = new GameObject();
    lightsObject.sprites = [{
        t: textures[6], x: 0, y: 0, w: 77, h: 533, ox: 0, oy: 0, d: 1000,
      },{
        t: textures[7], x: 0, y: 0, w: 77, h: 533, ox: 0, oy: 0, d: 1000,
      },{
        t: textures[8], x: 0, y: 0, w: 77, h: 533, ox: 0, oy: 0, d: 10000
      }];
    lightsObject.setPosition(1200, 450);
    lightsSpriteAnimation = new SpriteAnimationComponent();
    lightsSpriteAnimation.stop();
    lightsObject.addComponent(lightsSpriteAnimation);
    lightsObject.addComponent(spriteRenderingComponent);
    lightsObject.addComponent(new MoveComponent());

    tvScreen = new GameObject();
    tvScreen.setPosition(265, 45);
    tvScreen.bounds = [0,0,370,170];
    tvScreen.rotation = -0.13;
    // To show canvas from last frame i.e. recursive
    // var image = new Image();
    // tvScreen.addComponent(new DrawImageComponent(renderSystem, image));
    // tvScreen.addComponent(new SaveCanvasComponent(image, canvas));
    // To show canvas from current frame i.e. black square
    tvScreen.addComponent(new DrawImageComponent(renderSystem, canvas));

    // game.root.addObject(inputSystem);

    game.root.addObject(trackBackgroundObject);
    game.root.addObject(startLineObject);
    game.root.addObject(trackMarkingsObject);
    game.root.addObject(playerObject);
    game.root.addObject(aiObject);
    game.root.addObject(lightsObject);
    game.root.addObject(trackForegroundObject);
    game.root.addObject(tvScreen);

    game.root.addObject(worldSystem);
    game.root.addObject(cameraSystem);
    game.root.addObject(renderSystem);
  }

  function SaveCanvasComponent(image, canvas) {
    this.image = image;
    this.canvas = canvas;
  }
  SaveCanvasComponent.prototype = new GameComponent();
  SaveCanvasComponent.prototype.update = function (parent, delta) {
    this.image.src = this.canvas.toDataURL();
  }

  function DrawImageComponent(renderSystem, image) {
    this.renderSystem = renderSystem;
    this.image = image;
  }
  DrawImageComponent.prototype = new GameComponent();
  DrawImageComponent.prototype.update = function (parent, delta) {
    var bounds = parent.bounds,
        x = parent.position[0],
        y = parent.position[1],
        dx = bounds[0],
        dy = bounds[1],
        dw = bounds[2] - dx,
        dh = bounds[3] - dy,
        rotation = parent.rotation,
        image = this.image;
    this.renderSystem.push(function (ctx) {
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.drawImage(image, dx, dy, dw, dh);
    });
  }

  var playerSteps = 0,
      enemySteps = 0;
  // Export methods
  var exports = {
    setup,
    getGame () {
      return game;
    },
    start () {
      game.start();
    },
    stop () {
      game.stop();
    },
    movePlayerToStep (step) {
      pPIC.setPosition(PLAYER_X + POSITION_STEP * step, NaN);
    },
    moveEnemyToStep (step) {
      aPIC.setPosition(ENEMY_X + POSITION_STEP * step, NaN);
    },
    startCountdown () {
      lightsSpriteAnimation.play();
    },
    startMoving () {
      spriteAnimationComponent.play();
      trackMarkingsObject.setVelocity(TRACK_SPEED, 0);
      startLineObject.setVelocity(TRACK_SPEED, 0);
      lightsObject.setVelocity(TRACK_SPEED, 0);
    },
    finishRace () {
      startLineObject.setPosition(1500);
    },
    setPlayerFlame(active) {
      playerFlameComponent.setActive(active);
    },
    setEnemyFlame(active) {
      enemyFlameComponent.setActive(active);
    },
    setPlayerRacer (racer) {
      switch (racer) {
        case 'teal':  playerObject.sprites = tealSpriteSheet; break;
        case 'red':   playerObject.sprites = redSpriteSheet; break;
        case 'green': playerObject.sprites = greenSpriteSheet; break;
        case 'blue':  playerObject.sprites = blueSpriteSheet; break;
        default:      playerObject.sprites = tealSpriteSheet; break;
      }
      playerObject.sprite = playerObject.sprites[0];
    },
    setEnemyRacer (racer) {
      switch (racer) {
        case 'teal':  aiObject.sprites = tealSpriteSheet; break;
        case 'red':   aiObject.sprites = redSpriteSheet; break;
        case 'green': aiObject.sprites = greenSpriteSheet; break;
        case 'blue':  aiObject.sprites = blueSpriteSheet; break;
        default:      aiObject.sprites = tealSpriteSheet; break;
      }
      aiObject.sprite = aiObject.sprites[0];
    }
  }

  export default exports;



// WEBPACK FOOTER //
// ./src/js/game.js